export const weekDays = [
  { id: 0, name: 'Domingo' },
  { id: 1, name: 'Segunda' },
  { id: 2, name: 'Terça' },
  { id: 3, name: 'Quarta' },
  { id: 4, name: 'Quinta' },
  { id: 5, name: 'Sexta' },
  { id: 6, name: 'Sábado' },
];

// export function getWeekDays(): {
//   id: number;
//   name: string;
// }[] {
//   return [
//     { id: 0, name: 'Domingo' },
//     { id: 1, name: 'Segunda' },
//     { id: 2, name: 'Terça' },
//     { id: 3, name: 'Quarta' },
//     { id: 4, name: 'Quinta' },
//     { id: 5, name: 'Sexta' },
//     { id: 6, name: 'Sábado' },
//   ];
// }
